import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  Grid,
  Typography
} from '@mui/material';
import InfoModal from 'src/components/InfoModal';
import InfoPopupContent from 'src/__mocks__/InfoPopupContent';

function CollectedEnergyCard(props) {
  const { value } = props;
  let displayValue = 'No Data';
  if (!Number.isNaN(value)) {
    displayValue = `${Number(value).toFixed(2)} kWh`;
  }

  const cardStyle = {
    display: "block",
    height: "100%"
  };
  
  return (
    <Card style={cardStyle}>
      <CardContent>     
        <Typography
          color="textSecondary"
          gutterBottom
          variant="h6"
        >
          TOTAL ENERGY COLLECTED:
          <InfoModal content={InfoPopupContent.TOTAL_COLLECTED} />
        </Typography>
        <Typography
          color="textSecondary"
          gutterBottom
          variant="h4"
        >
          <b>{ displayValue }</b>
        </Typography>
      </CardContent>
    </Card>
  );
}

CollectedEnergyCard.propTypes = {
  value: PropTypes.number
};

export default CollectedEnergyCard;
